// extracted by mini-css-extract-plugin
export default {"label":"ChangePasswordModal_label__NbsEj","para":"ChangePasswordModal_para__NrULG","forgetPassword":"ChangePasswordModal_forgetPassword__TB88v"};